/**
 * Build a simple route shape for indoor/free placement without calling Google.
 * Named without "use" to avoid hook rules when used inside non-hook functions.
 * @param {Array} stopsForRoute
 * @returns {{ stops: any[], activeTrip: any }}
 */
export function buildIndoorPlacement(stopsForRoute = []) {
	const toCoords = (stop) => {
		const lat = Number.parseFloat(stop.lat);
		const lng = Number.parseFloat(stop.lng);
		return Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null;
	};

	const allStops = stopsForRoute
		.map((stop, index) => {
			const type =
				index === 0
					? 'origin'
					: index === stopsForRoute.length - 1
					? 'destination'
					: 'checkpoint';
			const fallbackLabel =
				type === 'origin'
					? 'Start'
					: type === 'destination'
					? 'Destination'
					: `Checkpoint ${String.fromCharCode(64 + index)}`;
			const label = stop.label || fallbackLabel;
			return {
				id: stop.id || index,
				coordinates: toCoords(stop),
				label,
				address: stop.address,
				name: stop.name || stop.label || stop.address || label,
				type,
			};
		})
		.filter((s) => s.coordinates);

	return {
		stops: allStops,
		activeTrip: {
			id: 'draft-route',
			name: 'Draft route',
			stops: allStops,
			polyline: allStops.map((s) => s.coordinates),
			checkpoints: allStops,
		},
	};
}
